import { type ReactNode } from 'react'
import { NotReady } from '@components'
import { useFeatureInfo } from '@front/model'
import { type FeatureId } from '@terros/common'
import { useRequiredParams } from '@util'
import { EditFeature } from './EditFeature'
import { createFileRoute } from '@tanstack/react-router'

type WithFeatureId = {
  featureId: FeatureId
}

function Feature(): ReactNode {
  const { featureId } = useRequiredParams<WithFeatureId>()

  const { data, isLoading, error, refetch, isFetching } = useFeatureInfo({ featureId })

  if (isLoading || error || !data?.feature || isFetching)
    return <NotReady data={data} error={error} id='feature' isLoading={isLoading || isFetching} />

  return <EditFeature feature={data.feature} isFetching={isFetching} refetch={refetch} />
}

export const Route = createFileRoute('/feature_/$featureId/')({
  component: Feature,
})
